// extracted by mini-css-extract-plugin
export default {"svg":"styles_svg__80Nz-","countdown":"styles_countdown__jKCDZ"};